export default __webpack_public_path__ + "static/media/walling-SQIpFNb0Nk4-unsplash-min.3a6e0412.jpg";